import React from 'react';
import { X } from 'lucide-react';

// Repeatable color-name + hex-picker rows for the Add/Edit product forms —
// builds the "Name: #hex, Name: #hex" string the backend expects
// (see backend/src/routes/inventory.js) from real inputs instead of having
// admins hand-type it, which is how existing data ended up with typos.
const ColorsInput = ({ rows, onAdd, onRemove, onUpdate }) => (
  <div>
    <div className="flex items-center justify-between mb-1.5">
      <label className="dpc-label text-ink-soft">Colors</label>
      <button type="button" onClick={onAdd} className="text-xs text-accent hover:text-accent-deep">
        + Add color
      </button>
    </div>
    <div className="space-y-2">
      {rows.map((row, index) => (
        <div key={index} className="flex items-center gap-2">
          <input
            type="text"
            value={row.name}
            onChange={(e) => onUpdate(index, 'name', e.target.value)}
            placeholder="e.g. Cerise Red"
            className="flex-1 border border-ink-faint rounded-sm px-3 py-2 text-sm bg-surface focus:ring-1 focus:ring-accent focus:border-accent"
          />
          <input
            type="color"
            value={/^#[0-9a-fA-F]{6}$/.test(row.code) ? row.code : '#000000'}
            onChange={(e) => onUpdate(index, 'code', e.target.value)}
            className="w-10 h-10 border border-ink-faint rounded-sm cursor-pointer shrink-0"
            aria-label={`Color swatch for ${row.name || 'this row'}`}
          />
          <input
            type="text"
            value={row.code}
            onChange={(e) => onUpdate(index, 'code', e.target.value)}
            placeholder="#000000"
            className="w-24 border border-ink-faint rounded-sm px-2 py-2 text-sm bg-surface focus:ring-1 focus:ring-accent focus:border-accent"
          />
          {rows.length > 1 && (
            <button type="button" onClick={() => onRemove(index)} className="p-2 text-ink-faint hover:text-accent" aria-label="Remove color">
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      ))}
    </div>
    <p className="text-xs text-ink-faint mt-1.5">Leave blank if this product only comes in one color.</p>
  </div>
);

export default ColorsInput;
